var _learnq = window._learnq || [];

var klaviyo = {
    addtoCart: function (item, data) {

        if (window.location.hostname != "www.neptune.com") {
            return;
        }

        try {
            var obj = {};
            if (data != null) {
                var cart = {
                    total_price: data.total_price / 100,
                    $value: data.total_price / 100,
                    total_discount: data.total_discount,
                    original_total_price: data.original_total_price / 100,
                    items: data.items
                }

                obj = cart;
            }
            else {
                var priceKeys = ["final_line_price", "original_price", "original_line_price", "line_price", "price", "discounted_price", "final_price"]
                Object.keys(item).forEach(k => {
                    if (priceKeys.filter(f => f == k).length > 0) {
                        item[k] = item[k] / 100;
                    }
                });

                obj = item;
            }
            var tracking = ['track', 'Added to Cart', obj];
            console.log("_learnq: klaviyon", tracking)
            _learnq.push(tracking);
        }
        catch (ex) {
            console.log(ex);
        }


    }

}
document.addEventListener("flu:cart:item-added",
    function (t) {
        klaviyo.addtoCart(t.detail.product, null);
        window.neptune.hj('event', 'add_to_cart');
    }),
    document.addEventListener("flu:cart:updated",
        function (t) {
            console.log("Cart updated", t.detail.cart);
            showMadeToOrderText(t.detail.cart);
            if (window.neptune.suft["init"]) {
                // Refreshes the stump up for trees module 
                // on the basket page.
                window.neptune.suft.init();
            }
        }),
    document.addEventListener("flu:cart:error",
        function (t) {
            console.log(t.detail.errorMessage, "Cart error");
        }),
    document.addEventListener("flu:quick-cart:open",
        function (t) {
            console.log("Quick cart opened", t.detail.cart);
            window.setHawkIndex();
            window.showMadeToOrderText(t.detail.cart)
        }),
    document.addEventListener("flu:quick-cart:close",
        function () {
            console.log("Quick cart closed");
        }),
    document.addEventListener("flu:product:variant-change",
        function (t) {
            // waits a moment before calling this - on ios calling this without a timeout results in a double click for the user.
            setTimeout(function () {
                console.log("Product variant changed", t.detail.variant);
                window.neptune.variant.update(t).then(e => {
                    window.neptune.variant.images.update();
                    typeof (window.neptune.configured["_glob"]) != "undefined" ? window.neptune.configured._glob.refresh(true) : null;
                });
            });
        }),
    document.addEventListener("flu:product:quantity-update",
        function (t) {
            console.log("Product quantity updated", t.detail.quantity, t.detail.variant);
        });

function findVariantById(id) {
    return Object.entries(ShopifyProduct).reduce((a, [variant, variantData]) => {
        variantData.id == id ? a[variant] = variantData : "";
        return a;
    },
        {});
}

function htmlDecode(input) {
    var e = document.createElement("textarea");
    e.innerHTML = input;
    // handle case of empty input
    return e.childNodes.length === 0 ? "" : e.childNodes[0].nodeValue;
}

function setHawkIndex() {
    const frame = document.querySelector('iframe[title="chat widget"]');

    if (frame == null) {
        return;
    }

    frame.parentNode.setAttribute('style', frame.getAttribute('style') + "; z-index:1!important;")
}

function showMadeToOrderText(cart) {
    var madeToOrder = []
    const basketMsgElement = document.querySelector('.js-madetoorder-basket');
    const cartNote = document.querySelector('.js-cart-note');
    if (basketMsgElement == null || cart == null || (basketMsgElement != null && basketMsgElement.innerText.length < 5)) {
        return;
    }

    cart.items.filter(e => e.properties != null).map(x => x.properties).forEach(f => {
        Object.keys(f).forEach(h => {
            if (h == "_AV | Availability" && f[h].toLowerCase().indexOf("to order") != -1) {
                madeToOrder.push(Math.random());
            }
        })
    })

    if (madeToOrder.length > 0) {
        basketMsgElement.style.display = "block";
        basketMsgElement.style.opacity = 1;
        basketMsgElement.style.height = (basketMsgElement.querySelector(".basket-text-inner").clientHeight) + "px";
        //cartNote.style.marginTop = "20px";
    }
    else {
        basketMsgElement.style.height = "0px";
        basketMsgElement.style.opacity = 0;
        basketMsgElement.style.display = "none";
        cartNote.style.marginTop = "0px";
    }

}

window.addEventListener('load', (e) => {
    /// When the window has loaded call the lazy loading library to check all 
    // images have the correct src set, without this instances were images are loaded in some carousels do not show the best quality image.
    window.lazySizes != null ? window.lazySizes.autoSizer.checkElems() : null;
})